var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadPhotos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 653,
    height: 653,
    viewBox: "0 0 653 653",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M652 326.038C652 506.072 506.072 652.075 325.962 652.075C145.853 652.075 0 506.072 0 326.038C0 146.004 145.928 0 326.038 0C506.147 0 652.075 145.928 652.075 326.038H652Z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M377.799 367.311C423.223 347.391 455.064 301.968 455.064 249.15C455.064 177.846 397.267 120.123 326.038 120.123C254.809 120.123 197.011 177.921 197.011 249.15C197.011 301.968 228.777 347.316 274.276 367.311C196.709 389.042 134.686 469.25 113.332 572.999C170.451 622.196 244.698 652.075 326.038 652.075C407.377 652.075 481.624 622.271 538.743 572.999C517.465 469.25 455.366 389.042 377.875 367.311H377.799Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhotos);
export default __webpack_public_path__ + "static/media/upload_photos.caef103cd9bbabef387d712dce0954fe.svg";
export { ForwardRef as ReactComponent };